export default class quarto {
    _id;
    _codigoQuarto;
    _descricao;
    _ativo;
    _setor;

    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }

    get codigoQuarto() {
        return this._codigoQuarto;
    }
    set codigoQuarto(value) {
        this._codigoQuarto = value;
    }

    get descricao() {
        return this._descricao;
    }
    set descricao(value) {
        this._descricao = value;
    }

    get ativo() {
        return this._ativo;
    }
    set ativo(value) {
        this._ativo = value;
    }

    get setor() {
        return this._setor;
    }
    set setor(value) {
        this._setor = value;
    }

    constructor(pId, pCodigoQuarto, pDescricao, pAtivo,pSetor) {
        this.id = pId;
        this.ativo = pAtivo;
        this.codigoQuarto = pCodigoQuarto;
        this.descricao = pDescricao;
        this.setor = pSetor;
    }
}